import { useRef, useState } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import {
  Box, Button, Center, Image, Spinner, Stack, Text, useDisclosure
} from '@chakra-ui/react'
import { ImagesPng } from 'assets/images'
import { SingleButton } from 'common/Buttons'
import { setProfileItemId, showCurrentChatFriendMarkerCoordinate, usersSelectors } from 'store'
import { NOTIFICATION_TYPE, PENDING, SUCCEEDED } from 'utils/constants'
import { generateDifferenceByDay } from 'utils/helpers'
import { COLORS } from 'utils/styles'
import { v4 as uuid } from 'uuid'

import { ConnectRequestModal } from './ConnectRequestModal'

export const ConnectionsRequest = ({
  notifications,
  // isAcceptLoading,
  // isRejectLoading,
  handleNotificationButton,
  selectId
}) => {
  const dispatch = useDispatch()
  const { getProfileItemStatus, profileItemId } = useSelector(usersSelectors)
  const [isNotifProfileDisplayed, setIsNotifProfileDisplayed] = useState(false)

  // Obsolete since profile can be viewed on notification panel
  const showFriendHandler = (item) => {
    const [lng, lat] = item?.coordinates
    const senderId = item.sender_id

    let coord = {
      coord: [
        Number(lng.toFixed(6)),
        Number(lat.toFixed(6))
      ],
      isStatic: true
    }
    dispatch(showCurrentChatFriendMarkerCoordinate(coord))
    document.querySelector('#back-button').click()
    localStorage.setItem('openProfileAfterAnimation', senderId)
  }

  return (
    <Stack
      spacing="55px"
      id="connection-request-list"
      // New Attributes for new design
      sx={{
        overflowX: 'auto',
        display: 'flex',
        flexDirection: 'row',
        gap: '10px'
      }}
      css={{
        '&::-webkit-scrollbar': {
          width: '4px',
          height: '10px',
          display: 'block'
        },
        '&::-webkit-scrollbar-track': {
          width: '6px'
        },
        '&::-webkit-scrollbar-thumb': {
          borderRadius: '24px',
          background: 'rgba(255, 215, 0, 1)'
        }
      }}
    >
      {notifications.map((item) => (
        <>
          {/* Old Design */}
          {/* <Stack direction="row" overflowX="none" key={uuid()}>
            <Image
              boxSize="60px"
              objectFit="cover"
              cursor="pointer"
              src={item.profile_picture ?? ImagesPng.DefaultImage}
              alt="User Image"
              borderRadius="full"
              // onClick={() => showFriendHandler(item)}
              onClick={() => {
                setIsNotifProfileDisplayed('inline-block')
                setIsImageClicked(true)
                dispatch(setProfileItemId(item?.sender_id))
                localStorage.setItem('id', item?.sender_id)
              }}
            />

            <Stack>
              <Stack>
                <Text>
                  <strong>
                    {item.sender_name}
                  </strong>
                  {' '}
                  sent you a connection request.
                </Text>
              </Stack>

              <Text fontSize="12px" color={COLORS.gray}>
                {generateDifferenceByDay(item.sent_at)}
              </Text>

              <Stack direction="row">
                <SingleButton
                  customStyled={{
                    paddingInline: '10px'
                  }}
                  isLoading={isAcceptLoading && selectId === item.sender_id}
                  text={NOTIFICATION_TYPE.View_Profile}
                  className="accept-btn"
                  click={() => showFriendHandler(item)}
                />
                <SingleButton
                  customStyled={{
                    paddingInline: '20px'
                  }}
                  isLoading={isAcceptLoading && selectId === item.sender_id}
                  text={NOTIFICATION_TYPE.Accept}
                  className="accept-btn"
                  click={() => handleNotificationButton({
                    id: item.sender_id,
                    type: NOTIFICATION_TYPE.Accept
                  })}
                />

                <SingleButton
                  customStyled={{
                    background: COLORS.metallic,
                    paddingInline: '20px'
                  }}
                  isLoading={isRejectLoading && selectId === item.sender_id}
                  click={() => handleNotificationButton({
                    id: item.sender_id,
                    type: NOTIFICATION_TYPE.Reject
                  })}
                  text={NOTIFICATION_TYPE.Reject}
                  className="reject-btn"
                />
              </Stack>
            </Stack>
          </Stack> */}

          {/* New Items for new connection request Design */}
          <Box
            key={uuid()}
            cursor="pointer"
            onClick={() => {
              setIsNotifProfileDisplayed(true)
              dispatch(setProfileItemId(item?.sender_id))
              localStorage.setItem('friendReqID', item?.friend_request_id)
              localStorage.setItem('id', item?.sender_id)
            }}
            sx={{
              minWidth: '120px',
              marginTop: '5px'
            }}
            data-name="notificationItem"
          >
            {getProfileItemStatus === PENDING && item?.sender_id === profileItemId
              ? (
                <Center>
                  <Spinner
                    key={uuid()}
                    width="70px"
                    height="70px"
                    position="absolute"
                    marginTop="110px"
                    zIndex={5}
                  />
                </Center>
              ) : null }
            <Image
              key={uuid()}
              width="120px"
              height="120px"
              opacity={
                getProfileItemStatus === PENDING
                && item?.sender_id === profileItemId ? 0.7 : 1
              }
              objectFit="cover"
              src={item.profile_picture ?? ImagesPng.DefaultImage}
              alt={item?.title}
            />
          </Box>

          <ConnectRequestModal
            key={uuid()}
            requestId={item?.sender_id}
            selectId={selectId}
            handleNotificationButton={handleNotificationButton}
            isNotifProfileDisplayed={isNotifProfileDisplayed}
            setIsNotifProfileDisplayed={setIsNotifProfileDisplayed}
            getProfileItemStatus={getProfileItemStatus}
            friendRequestID={item?.friend_request_id}
          />
        </>
      ))}
    </Stack>
  )
}
